import { render, staticRenderFns } from "./AvailabilityFunds.vue?vue&type=template&id=f72b57ae&scoped=true"
import script from "./AvailabilityFunds.vue?vue&type=script&lang=js"
export * from "./AvailabilityFunds.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityFunds.vue?vue&type=style&index=0&id=f72b57ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b57ae",
  null
  
)

export default component.exports